import { Schema, type } from "@colyseus/schema";

/** Default projectile travel speed (world units / second). Tunable (D3). */
export const PROJECTILE_SPEED = 24;
/** Centre-to-centre distance (u) at which a projectile resolves on its target. */
export const HIT_RADIUS = 0.6;
/** A cube fires a projectile when its derived attackRange exceeds this (u);
 *  at or below it the cube swings melee. The 15 ranged weapons carry 3.5–7u. */
export const MELEE_RANGE_MAX = 1.5;

/**
 * A travelling basic-attack projectile (arrow / bolt / wand-mote / bullet).
 * Homing (D1): it tracks the target's current position each server tick and
 * resolves damage on impact. Damage is captured at spawn from the shooter's
 * attackDamage and re-resolved through fireSwingDamage_* at impact (D4).
 * FoW-gated on HelloState like creatures/buildings.
 */
export class Projectile extends Schema {
  @type("string") id!: string;
  @type("number") x: number = 0;
  @type("number") z: number = 0;
  /** Launch origin — client arcs from here; server measures travelled distance. */
  @type("number") spawnX: number = 0;
  @type("number") spawnZ: number = 0;
  @type("string") sourceId: string = "";
  @type("string") targetId: string = "";
  @type("uint8")  teamId: number = 0;
  @type("uint16") damage: number = 0;
  @type("number") speed: number = PROJECTILE_SPEED;
  /** Accumulated distance flown (u) — drives the distance-damage passive (D5). */
  @type("number") travelled: number = 0;
  /** Damage kind for impact resolution + client tint. v1: "physical". */
  @type("string") kind: string = "physical";
}
